import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { AcademypaymentService } from 'src/app/services/academyPayment';
import { DateValidator } from 'src/app/_helpers/must-match.validator';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-batch-enrolment',
  templateUrl: './user-batch-enrolment.component.html',
  styleUrls: ['./user-batch-enrolment.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class UserBatchEnrolmentComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = '';
  statuses: any[];
  paymentModes: any[];
  searchBy: any[];
  rowGroupMetadata: any;
  totalRecords: 0;
  virtualDatabase: any;
  batchEnrolmentList: any;
  userRoleId;
  userdetail: any;
  public item: any[] = [];
  public academyName;
  loading: boolean;
  paginationOption;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  yearRange;
  minYear = environment.minYear;
  stDate: Date = new Date();
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadUserPaymentsList: any;
  searchby;
  wdcalvalue;
  public hide: boolean = true;
  public catList: any[] = [];
  public brandList: any[] = [];
  public showFileUploadModal: boolean = false;
  public academyCsvFile;
  public uploadCsvFile: any[] = [];
  public academyImages: any[] = [];
  public uploadImageFiles: any[] = [];
  public showFileErrors: boolean = false;
  public showImageFileUploadModal: boolean = false;
  public showImageFileErrors: boolean = false;
  public editTransaction: boolean = false;
  public transvalue;
  public expiryvalue;
  public academyDetails;
  public editPaymentForm: FormGroup;
  public transactionSubmitted: boolean = false;
  public minimumDate = new Date();
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId1", { static: false }) pDropDownId1: Dropdown;
  @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
  profileDetails: any;
  userName: any;
  id: string;
  constructor( private academyPaymentService: AcademypaymentService, private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService,    
    private formBuilder: FormBuilder,
    private activeroute: ActivatedRoute,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.id = this.activeroute.snapshot.params.id;
    this.yearRange = environment.yearRange;
    this.statuses = [
      { label: 'Active', value: "Active" },
      { label: 'Expired', value: "Expired" }
    ];
    this.paymentModes = [
      { label: 'Online', value: "online" },
      { label: 'Offline', value: "offline" }
    ];
    this.searchBy = [
      { label: 'Start Date', value: "startDate" },
      { label: 'End Date', value: "endDate" }
    ];
    this.downloadFlg = false;
    this.editPaymentForm = this.formBuilder.group({
      academyId: [],
      paymentId: [],
      transactionDate: ['', [Validators.required]],
      expiryDate: ['', [Validators.required]]
    }, {
      validator: DateValidator('transactionDate', 'expiryDate')
    });
    this.getUserDetails(this.id);
  }

  getUserDetails(userId) {
    this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
          this.userName = this.profileDetails?.fullName;
        }

      }, err => {

      });

  }

  get f() {
    return this.editPaymentForm.controls;
  }
  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'batch', 'contains');
    this.dt.filter('', 'academyName', 'contains');
    this.dt.filter('', 'level', 'contains');
    this.dt.filter('', 'ageGroup', 'contains');
    this.dt.filter('', 'transactionDate', 'contains');
    this.dt.filter('', 'startDate', 'dateIs');
    this.dt.filter('', 'endDate', 'dateIs');
    this.dt.filter('', 'statename', 'contains');
    this.dt.filter('', 'cityname', 'contains');
    this.dt.filter('', 'batchStatus', 'contains');
    this.dt.filter('', 'paymentDone', 'contains');
    this.transvalue = null;
    this.expiryvalue = null;
    this.pDropDownId1.clear(null);
    this.pDropDownId2.clear(null);
    if (this.pDropDownId1) {
      this.pDropDownId1.value = null;
    }
    if (this.pDropDownId2) {
      this.pDropDownId2.value = null;
    }
  }

  loadUserBatchEnrolments(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    let query = "filterByDisable=false&filterByStatus=true&filterByPlayerId=" + this.id;
    let pagenumber = 1;
    let params = "";
    let rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["batch"] != undefined) {
      params += "&filterByBatchName=" + event.filters["batch"].value;
    }
    if (event.filters != undefined && event.filters["academyName"] != undefined) {
      params += "&filterByAcademyName=" + event.filters["academyName"].value;
    }
    if (event.filters != undefined && event.filters["level"] != undefined) {
      params += "&filterByLevel=" + event.filters["level"].value;
    }
    if (event.filters != undefined && event.filters["ageGroup"] != undefined) {
      params += "&filterByAgeGroup=" + event.filters["ageGroup"].value;
    }
    if (event.filters != undefined && event.filters["startDate"] != undefined) {
      const batchStartDate = moment(event.filters["startDate"].value).format("YYYY-MM-DD");
      params += "&filterByBatchStartDate=" + batchStartDate;
    }
    if (event.filters != undefined && event.filters["endDate"] != undefined) {
      const batchEndDate = moment(event.filters["endDate"].value).format("YYYY-MM-DD");
      params += "&filterByBatchEndDate=" + batchEndDate;
    }
    if (event.filters != undefined && event.filters["statename"] != undefined) {
      params += "&filterByState=" + event.filters["statename"].value;
    }
    if (event.filters != undefined && event.filters["cityname"] != undefined) {
      params += "&filterByCity=" + event.filters["cityname"].value;
    }
    if (event.filters != undefined && event.filters["batchStatus"] != undefined) {
      params += "&filterByBatchStatus=" + event.filters["batchStatus"].value;
    }
    if (event.filters != undefined && event.filters["paymentDone"] != undefined) {
      params += "&filterBypaymentDone=" + event.filters["paymentDone"].value;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      let orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    /**
    * Sequence wise sort.
    **/
    // else {
    //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
    // }
    this.userService.getPlayerBatchEnrolledList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (this.downloadFlg === false) {
          this.loading = false;
          this.batchEnrolmentList = data.data.items;
          this.totalRecords = data.data.totalCount;
        } else {
          this.exportExcelData(data.data.items);
          this.downloadFlg = false;
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  func(prop, val) {
    let jsonStr = '{"' + prop + '":"' + val + '"}';
    return JSON.parse(jsonStr);
  }

  editTrasaction(academy) {
    this.editTransaction = true;
    this.editPaymentForm.get('academyId').setValue(academy['academyId']);
    this.editPaymentForm.get('paymentId').setValue(academy['id']);
    if (academy['transactionDate']) {
      this.editPaymentForm.get('transactionDate').setValue(moment(academy['transactionDate']).format('DD-MM-YYYY'));
    }
    if (academy['expiryDate']) {
      this.editPaymentForm.get('expiryDate').setValue(moment(academy['expiryDate']).format('DD-MM-YYYY'));
    }
  }
  stdt: Date;
  eddt: Date;
  setStartDate($event) {
    this.stdt = $event; //moment($event).format("MM/DD/YYYY");
  }
  setEndDate($event) {
    this.eddt = $event; //moment($event).format("MM/DD/YYYY");
  }
  onSubmit() {
    this.transactionSubmitted = true;
    if (this.editPaymentForm.invalid) {
      return;
    }
    let paymentData = this.editPaymentForm.value;
    let paymentId = paymentData['paymentId'];
    // if (this.stdt != undefined) {
    //     paymentData['transactionDate'] = moment(this.stdt).toDate();
    // }
    // if (this.eddt != undefined) {
    //     paymentData['expiryDate'] = moment(this.eddt).toDate();
    // }

    if (this.editPaymentForm.value.transactionDate instanceof Date) {
      paymentData['transactionDate'] = moment(this.editPaymentForm.value.transactionDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    } else {
      var dt = moment(this.editPaymentForm.value.transactionDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      paymentData['transactionDate'] = dt;
    }

    if (this.editPaymentForm.value.expiryDate instanceof Date) {
      paymentData['expiryDate'] = moment(this.editPaymentForm.value.expiryDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    } else {
      var dt = moment(this.editPaymentForm.value.expiryDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      paymentData['expiryDate'] = dt;
    }


    delete paymentData['academyId'];
    let updateData = JSON.stringify(paymentData, null, 4);
    this.academyPaymentService.updateAcademyPayment(paymentId, updateData).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Subscription Dates updated', life: 3000 });
        this.editTransaction = false;
        this.loadUserBatchEnrolments(this.lastTableLazyLoadEvent);
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  editTransactionClose() {
    this.editTransaction = false;
  }

  addNewAcademyPayment() {
    this.router.navigate(['/manage/academies/add']);
  }

  viewAcademyPayment(id) {
    this.router.navigate(['/manage/academies/view/' + id]);
  }

  editAcademyPayment(id) {
    this.router.navigate(['/manage/academies/edit/' + id]);
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.batchEnrolmentList.length; i++) {
      if (this.batchEnrolmentList[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  editmedia(id) {
    this.router.navigate(['manage/academies/media/' + id]);
  }

  showUploadModal() {
    this.showFileUploadModal = true;
  }
  showImageUploadModal() {
    this.showImageFileUploadModal = true;
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadUserBatchEnrolments(this.lastTableLazyLoadEvent);
  }

  exportExcelData(batchEnrolmentList) {
    let propertiesRemove = ['ageGroupId', 'attendanceHistory', 'batchCapacity', 'batchDays', 'batchId', 'batchPlayerId', 'academyId', 'id', 'created_at', 'createdBy', 'updatedby',
      'disable', 'updated_at', 'location', 'nextSessionTime', 'status', 'created_by', 'playerId', 'invoiceFile', 'playerMobileNumber', 'playerName', 'profilePic', 'rating'];
    this.downloadUserPaymentsList = batchEnrolmentList;
    this.downloadUserPaymentsList.forEach(function (item) {
      if (item.startdate != '') {
        item['startDate'] = moment(item.startDate).format('DD-MM-YYYY');
      }
      if (item.endDate != '') {
        item['endDate'] = moment(item.endDate).format('DD-MM-YYYY');
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadUserPaymentsList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "User_Batch_Enrolments_Details");
    });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  /**
   * Use to add more columns in the table.
  */
  addColumns() {
    this.hide = false;
  }

  /**
  * Use to remove more columns in the table.
  */
  removeColumns() {
    this.hide = true;
  }

  academyPayment(id) {
    this.router.navigate(['/payments' + id]);
  }

  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }

  markFree(id, status) {
    let markedStr: string;
    let paymentStatus: string;
    let successMsg: string;

    if (status === 'created') {
      markedStr = 'Do you want to assign Free membership?';
      paymentStatus = 'free';
      successMsg = 'Marked as Free Successfully';
    } else {
      markedStr = 'Do you want to cancel Free membership?';
      paymentStatus = 'created';
      successMsg = 'Free Membership Cancelled Successfully';
    }

    this.confirmationService.confirm({
      message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        ${markedStr}
      </p>
    `,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const updateData = JSON.stringify({ status: paymentStatus });

        this.academyPaymentService
          .updateAcademyPayment(id, updateData).pipe(takeUntil(this.destroy$))
          .subscribe(
            () => {
              this.messageService.add({
                key: 'toastmsg',
                severity: 'success',
                summary: 'Successful',
                detail: successMsg,
                life: 3000
              });

              this.loadUserBatchEnrolments(this.lastTableLazyLoadEvent);
            },
            err => {
              this.errorMessage = err.error.message;
            }
          );
      },
      reject: () => {
        this.loadUserBatchEnrolments(this.lastTableLazyLoadEvent);
      }
    });
  }

  sendInvoice(subscriptionId: string) {
    let markedStr = "Do you want to regenerate invoice ?"
    this.confirmationService.confirm({
      message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        ${markedStr}
      </p>
    `,

      // message: markedStr,
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.userService.generateUserSubscriptionInvoice(subscriptionId).pipe(takeUntil(this.destroy$)).subscribe(
          (data: Blob) => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'invoice regenerated', life: 3000 });
            setTimeout(() => {
              this.loadUserBatchEnrolments(this.lastTableLazyLoadEvent);
            }, 2000);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.loadUserBatchEnrolments(this.lastTableLazyLoadEvent);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
